<script lang="ts" setup name="RouterTabsLink">
import type { LocationAsRelativeRaw } from 'vue-router';
import { RouterLink } from 'vue-router';

import Icon from '~/components/Icon.vue';

import type { IconType } from '~/types';

defineProps<{
  label?: string;
  subLabel?: string;
  icon?: IconType;
  to: LocationAsRelativeRaw;
  enabled?: boolean;
  width: number;
  minWidth: number;
}>();
</script>

<template>
  <RouterLink
    :key="label"
    :to="to"
    custom
    v-slot="{ href, navigate, isActive }"
  >
    <a
      :href="href"
      @click="navigate"
      class="relative flex flex-col items-center space-y-2 whitespace-nowrap border-b-4 bg-white text-center text-xs"
      :class="{
        'px-4 pb-3 pt-4': label,
        'p-4': !label,
        'border-primary-8 text-primary-8 hover:bg-green-0':
          isActive && !!to?.name,
        'border-white text-charcoal-6 hover:border-charcoal-0 hover:bg-charcoal-0':
          !isActive || !to?.name,
      }"
      :style="{
        width: `${width}px`,
        minWidth: `${minWidth}px`,
      }"
    >
      <Icon v-if="icon" :icon="icon" class="h-5 w-5" />
      <p v-if="label" class="uppercase">
        {{ label }}
      </p>
      <p v-if="subLabel" class="capitalize">
        {{ subLabel }}
      </p>
    </a>
  </RouterLink>
</template>
